import { useNavigate } from "react-router-dom";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import "./BreadCrumbComponent.scss";

const BreadCrumbComponent = ({ crumbList }) => {

    const navigate = useNavigate()

    const goToPage = (link) => {
        if (link) {
            navigate(link)
        }
    }

    return (
        <>
            <div className="breadcrumb-row">
                {
                    crumbList.map((menu, list) => {
                        return (
                            <div className={`crumb-name-wrap d-flex align-itemes-center gap-1`}>
                                {
                                    menu.isLoading ?
                                        <ShimmerScreen 
                                        case="rect"
                                        width="5rem"
                                        height="1rem"
                                        />
                                    :
                                    <span 
                                        className={`crumb-name ${menu.active ? 'active' : ''}`}
                                        onClick={() => goToPage(menu.link)}
                                    >
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: menu.name
                                            }}
                                        ></span>
                                    </span>
                                }
                                {
                                    crumbList[list + 1]?.name ?
                                        <span className="chevron-span">
                                            <img src="/images/chevron-right.svg" alt="" />
                                        </span>
                                        : ""
                                }
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default BreadCrumbComponent